// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getStatusConstants} from '../../../shared/repositories';

export const updateDemoRentalStatuses = () =>
    dispatch => getStatusConstants()
        .then(data => dispatch({
            data,
            type: actions.UPDATE_DEMO_RENTAL_STATUS_SUCCESS
        }));




// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/action-creators/statuses.js